import { Skeleton, useTheme } from '@mui/material'

interface SkeletonIssueCardProps {
  variant: 'large' | 'small'
  count?: number
}

const SkeletonIssueCard = ({ variant, count = 3 }: SkeletonIssueCardProps) => {
  const isLarge = variant === 'large'
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  
  const containerBg = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.06)'
  
  return (
    <div style={{ display: 'flex', gap: isLarge ? 20 : 16, padding: '0 10px' }}>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          style={{ 
            minWidth: isLarge ? 240 : 160,
            padding: '0 8px'
          }}
        >
          <div 
            style={{
              borderRadius: isLarge ? 16 : 12,
              padding: isLarge ? '16px' : '12px',
              marginBottom: isLarge ? 12 : 10,
              backgroundColor: containerBg
            }}
          >
            <Skeleton 
              variant="rectangular" 
              width="100%" 
              height={isLarge ? 300 : 160}
              style={{ borderRadius: 8 }}
            />
          </div>
          <Skeleton 
            variant="text" 
            width="80%" 
            height={isLarge ? 24 : 20}
            style={{ marginBottom: 6 }}
          />
          <Skeleton 
            variant="text" 
            width="60%" 
            height={isLarge ? 16 : 14}
          />
        </div>
      ))}
    </div>
  )
}

export default SkeletonIssueCard